var _g, _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle3, _circle4, _path1, _path10, _path11, _circle5, _circle6, _path12, _circle7, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBat40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 126,
    viewBox: "0 0 192 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_50290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8182 4.09931C48.7772 1.47557 52.3181 0.599273 54.8182 0.0993072C57.3184 -0.400659 64.3181 1.09925 66.3182 2.09931C68.3184 3.09936 69.8174 10.0994 74.8174 11.5994C79.8174 13.0994 170.317 10.5994 173.317 10.5994C176.318 10.5994 180.817 14.7799 180.817 18.0994V28.5994C180.817 32.5994 180.817 35.5993 177.817 37.0994C173.317 39.3494 173.469 40.1721 171.817 42.0994C170.165 44.0267 170.215 44.6335 170.818 47.0993C171.719 50.7822 174.281 52.2816 176.817 55.0994C181.318 60.0994 182.483 61.1722 184.317 66.0994C186.582 72.1823 187.295 76.1086 187.317 82.5994C187.341 89.284 186.251 92.5923 183.318 98.5994C179.982 105.434 175.487 109.444 168.818 113.099C164.269 115.593 161.006 115.599 155.817 115.599C147.817 115.599 144.352 115.18 136.818 113.099C131.698 111.685 128.975 110.371 123.818 109.099C111.817 106.139 79.4527 107.493 72.8174 108.599C69.8174 109.099 61.8174 112.109 57.3174 114.099C51.9602 116.469 46.8174 117.599 40.8174 117.599C34.8884 117.599 29.8174 116.099 27.3174 115.099C24.8174 114.099 18.3174 110.099 16.8174 108.599C15.3174 107.099 9.88571 100.63 7.81825 94.5993C5.63201 88.2221 4.40342 84.328 4.81825 77.5993C5.2742 70.2037 6.52381 65.6376 10.8183 59.5993C14.2676 54.7493 17.1425 52.5374 22.3183 49.5993C29.3197 45.6249 38.3174 46.5994 42.3182 44.5993C46.4105 42.5536 47.86 39.7342 49.8182 35.5993C52.0994 30.7826 53.5756 24.833 51.8182 22.0993L47.3182 15.0993C44.0443 10.7823 42.8593 6.72304 45.8182 4.09931Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.729 27.1144C130.325 29.537 125.457 30.9656 120.433 28.7295C111.206 27.008 104.282 24.8936 104.08 23.8842C103.878 22.8747 106.705 22.6729 106.705 22.6729H111.752L121.038 22.8747L126.893 22.6729C129.802 23.4717 131.133 24.6917 130.729 27.1144Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1018 82.8356L45.1301 79.8073L53.6094 56.9941L48.7641 55.7828L50.1773 50.5337C50.1773 50.5337 51.3886 46.2943 50.9848 45.4866C50.5811 44.6789 47.0493 50.6849 45.1301 58.0035L47.3509 59.6186L40.2849 81.2204L42.1018 82.8356Z",
    fill: "#ECEBEB",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4449 43.0635L58.1699 40.6358L55.8298 39.9834L55.2241 41.0446L53.0034 42.8616L50.3789 52.5521L52.3977 53.5616L54.4166 46.6974L55.8298 46.0918L57.4449 43.0635Z",
    fill: "#797979",
    stroke: "#797979"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 45.332 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 72.3848 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3794 57.1959L34.0266 105.043M68.953 88.8921L15.6549 72.5393M26.3549 59.6185L59.6662 103.832M66.1266 68.5015L17.27 93.5355M37.2568 55.3789L47.553 106.86M60.07 60.0223L23.9323 102.015M15.2511 83.2393L70.3662 77.9902",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.165 53.5614L121.039 56.3878L122.048 52.552C122.406 51.6625 122.404 51.2105 121.846 50.5331L119.02 49.3218C117.059 49.0574 116.057 49.1813 114.376 49.7255L113.165 53.5614Z",
    fill: "black",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4532 25.3035L62.4105 25.9559C62.4105 25.9559 64.866 22.4225 64.5108 19.8463C64.388 18.9558 64.2172 18.4685 63.9051 17.6255C62.6252 14.1687 54.7464 12.8348 57.6466 10.5595C58.0083 10.2757 58.3717 10.3151 58.656 9.95384C59.4559 8.93782 57.4449 7.32942 56.6372 6.72376C55.8296 6.1181 53.818 4.43606 53.407 5.71422C53.155 6.49783 54.2965 6.96044 54.0127 7.73309C53.8767 8.10312 53.6105 8.20301 53.407 8.54064C52.6643 9.77287 52.075 10.9327 52.8013 12.1746C53.3203 13.0619 54.167 13.0172 55.0221 13.5878C56.4782 14.5595 57.4063 14.9865 58.656 16.2123C60.1086 17.6371 61.3611 18.4431 61.6843 20.452C62.0131 22.4952 60.4532 25.3035 60.4532 25.3035Z",
    fill: "#797979",
    stroke: "#797979"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.358 46.8995L114.579 47.5052L120.231 28.7297L117.809 28.3259L112.358 46.8995Z",
    fill: "#ECEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.752 46.8995L114.982 47.707L112.762 53.7636L121.039 56.5901L120.635 58.2052L153.543 77.7882L155.562 80.8165L152.533 80.6146L119.828 60.8297L111.954 86.2674L114.579 86.8731L115.386 84.6523L151.12 81.2202V84.0466L118.616 87.4787L117.607 87.8825L117.001 95.3523L102.667 91.9202L101.658 88.8919L82.0748 71.5297L70.971 55.3787L61.0785 38.2184L59.8672 37.6127L58.8578 40.641L55.4257 39.2278L59.4634 25.4995L63.0974 26.7108V28.7297C72.4937 49.3692 77.5677 58.0072 86.1125 66.0787C93.3259 69.1193 97.4604 70.0375 105.09 69.5108L111.752 46.8995Z",
    fill: "#ECEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.358 46.8995L114.579 47.5052L120.231 28.7297L117.809 28.3259L112.358 46.8995Z",
    stroke: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M111.752 46.8995L114.982 47.707L112.762 53.7636L121.039 56.5901L120.635 58.2052L153.543 77.7882L155.562 80.8165L152.533 80.6146L119.828 60.8297L111.954 86.2674L114.579 86.8731L115.386 84.6523L151.12 81.2202V84.0466L118.616 87.4787L117.607 87.8825L117.001 95.3523L102.667 91.9202L101.658 88.8919L82.0748 71.5297L70.971 55.3787L61.0785 38.2184L59.8672 37.6127L58.8578 40.641L55.4257 39.2278L59.4634 25.4995L63.0974 26.7108V28.7297C72.4937 49.3692 77.5677 58.0072 86.1125 66.0787C93.3259 69.1193 97.4604 70.0375 105.09 69.5108L111.752 46.8995Z",
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.283,
    cy: 30.283,
    r: 28.783,
    transform: "matrix(-1 0 0 1 181.807 50.5337)",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 4.23019,
    transform: "matrix(-1 0 0 1 154.754 77.5864)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M159.801 57.1959L143.448 105.043M178.375 88.8921L125.077 72.5393M135.777 59.6185L169.088 103.832M175.548 68.5015L126.692 93.5355M146.679 55.3789L156.975 106.86M169.492 60.0223L133.354 102.015M124.673 83.2393L179.788 77.9902",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.456 79.2011L151.928 78.3936L152.13 83.2388L101.053 93.9388",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.695 81.2201L103.878 84.6522L104.686 86.0654L108.724 86.873L108.32 88.69L104.484 87.8824L103.475 89.2956L103.676 92.9296H101.859V89.6994L99.4368 88.8918L96.6104 90.305L96.0048 88.69L98.8312 87.2767L99.0331 85.6617L96.4085 83.0371L97.418 81.6239L100.446 84.2484L102.061 83.8447L103.878 80.4126L105.695 81.2201Z",
    fill: "black",
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.27736,
    cy: 8.27736,
    r: 6.77736,
    transform: "matrix(-1 0 0 1 110.339 78.3936)",
    stroke: "black",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23019,
    cy: 3.23019,
    r: 3.23019,
    transform: "matrix(-1 0 0 1 105.09 83.6426)",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.005 101.61L102.062 89.0935L102.869 86.6708L101.052 85.8633L99.2352 88.6897L93.3805 101.61H90.7559V103.629L91.7654 105.043H97.6201L98.8314 104.033V101.61H96.005Z",
    fill: "black",
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.81698,
    cy: 1.81698,
    r: 1.81698,
    transform: "matrix(-1 0 0 1 56.2344 4.09961)",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.44 21.1948H146.694V31.9704H139.44V21.1948Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.625 15.25C138.133 15.25 136.702 15.8426 135.648 16.8975C134.593 17.9524 134 19.3832 134 20.875V32.125C134 33.6168 134.593 35.0476 135.648 36.1025C136.702 37.1574 138.133 37.75 139.625 37.75H167.75C169.242 37.75 170.673 37.1574 171.727 36.1025C172.782 35.0476 173.375 33.6168 173.375 32.125V20.875C173.375 19.3832 172.782 17.9524 171.727 16.8975C170.673 15.8426 169.242 15.25 167.75 15.25H139.625ZM167.75 18.0625C168.496 18.0625 169.211 18.3588 169.739 18.8863C170.266 19.4137 170.562 20.1291 170.562 20.875V32.125C170.562 32.8709 170.266 33.5863 169.739 34.1137C169.211 34.6412 168.496 34.9375 167.75 34.9375H139.625C138.879 34.9375 138.164 34.6412 137.636 34.1137C137.109 33.5863 136.812 32.8709 136.812 32.125V20.875C136.812 20.1291 137.109 19.4137 137.636 18.8863C138.164 18.3588 138.879 18.0625 139.625 18.0625H167.75ZM179 26.5C179 27.6189 178.556 28.6919 177.764 29.4831C176.973 30.2743 175.9 30.7188 174.781 30.7188V22.2812C175.9 22.2812 176.973 22.7257 177.764 23.5169C178.556 24.3081 179 25.3811 179 26.5Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_50290",
    x: 0.738281,
    y: 0,
    width: 190.579,
    height: 125.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_50290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_50290",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat40);
export default __webpack_public_path__ + "static/media/bat_40.50d554816c1571090782292818661126.svg";
export { ForwardRef as ReactComponent };